/**
 * 金額の通貨表記 (Issue #752)。admin / driver の全画面で `1,500円` に統一する。
 * 表示規約は `docs/05_ui/01_overview.md` の「金額表示の共通方針」を参照。
 *
 * 「空・未記録・算出不能」のときの表示はここでは決めない。画面ごとに意味が違うため
 * (`""` / `未記録` / `未設定` / `未算出` / `未登録` / `—`)、呼び出し側が分岐したうえで
 * 数値だけを渡す。税計算もここでは行わない。整形するのは通貨表記だけ。
 */

/** 桁区切りは実行環境の既定ロケールに委ねない (de-DE だと `1.500` になる)。 */
const LOCALE = "ja-JP";
/** 円に補助単位は無いので小数は出さない。非整数は四捨五入して整数の金額として表す。 */
const YEN_DIGITS = { maximumFractionDigits: 0 } as const;
/** 省略表記に切り替える下限。1 万円以上を `1.2万円` にする。 */
const MAN = 10000;

/** 金額を `1,500円` で表示する。0 円・負数もそのまま金額として表す。 */
export function formatYen(amount: number): string {
  return `${amount.toLocaleString(LOCALE, YEN_DIGITS)}円`;
}

/**
 * 一覧の狭い枠向けの省略表記。1 万円以上を `1.2万円` に丸める。
 * 万単位の商にも桁区切りを入れる (入れないと `123456.8万円` となり元より読みにくい)。
 * 判定は絶対値で行う (符号で表記が変わると 0 をまたいだときにセル幅が動く)。
 */
export function formatYenCompact(amount: number): string {
  if (Math.abs(amount) < MAN) return formatYen(amount);
  const man = (amount / MAN).toLocaleString(LOCALE, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return `${man}万円`;
}
